module.exports = __webpack_public_path__ + "static/5-a52d1e49b3f1d16045c7ef1b0d2ec674.jpg";